import AppButton from '@/components/ui/app-button';
import Modal from '@/components/ui/modal';
import { useTranslations } from 'next-intl';

interface Props {
    isOpen: boolean;
    onClose(): void;
    onConfirm(): void;
}

export const ConfirmPublicationModal = ({ isOpen, onClose, onConfirm }: Props) => {
    const t = useTranslations();

    const handleConfirmation = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal
            customClass="inset-x-0 top-0 bottom-0 z-50 transition-all duration-300 ease-in-outpy-3 "
            isOpen={isOpen}
            onClose={onClose}
            ModalSize="max-w-[580px] w-full"
            modalPadding="py-[20px] pt-[60px] pb-[37px]"
            closePosition="right-[40px] top-[20px]"
        >
            <div className="w-full flex flex-col text-center items-center justify-center">
                <h3 className="text-center text-2xl font-bold mb-[30px]">{t('Programs.publishProgram.title')}</h3>
                <p className="text-center text-sm mb-[20px] px-[16px]">{t('Programs.publishProgram.subtitle')}</p>
                <p className="text-center text-sm mb-[40px] px-[20px]">
                    {t.rich('Programs.publishProgram.description', {
                        link: (chunks) => (
                            <a
                                href="https://doc.bunqer.tech/Terms-conditions-25504e781dc280189385dd68fe1001ce"
                                target="_blank"
                                className="underline text-white"
                                rel="noreferrer"
                            >
                                {chunks}
                            </a>
                        ),
                    })}
                </p>
                <div className="flex gap-[20px]">
                    <AppButton
                        innerText={t('Programs.publishProgram.cancelButton')}
                        customClassName="py-[15px] px-[30px] font-medium mx-auto text-[14px] border-1 text-sm"
                        onClick={onClose}
                    />
                    <AppButton
                        innerText={t('Programs.publishProgram.confirmButton')}
                        btnBgColor="#DD06AE"
                        borderColor="#DD06AE"
                        customClassName="py-[15px] px-[30px] font-medium mx-auto text-[14px] border-1 text-sm"
                        onClick={handleConfirmation}
                    />
                </div>
            </div>
        </Modal>
    );
};
